import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, submitOwnershipTransferCustomer } from '../OwnershipTransferCustomerSlice';
import { OwnershipTransferCustomerStep } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PaymentCG from '../../SaleBlock/PaymentCG/PaymentCG';
import { cgTypeEnum } from '../../../../utilities/enums/cgTypeEnum';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const CustomerPaymentMethod = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.PaymentMethodPage,
        messageText: DWHMessageText.PaymentMethodPageDisplayed,
        status: DWHStatus.Ongoing
      });
    }
  }, []);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  const submitTransfer = () => {
    dwhGeneralReport({
      data: { ...props.data, userDetails: props.userDetails },
      actionType: DwhActionType.PaymentMethodPage,
      messageText: DWHMessageText.PaymentMethodPageButtonClicked,
      status: DWHStatus.Ongoing
    });
    let data = {
      CCToken: props.paymentCg.CCToken,
      CardYear: props.paymentCg.form.CardDueYear,
      CardMonth: props.paymentCg.form.CardDueMonth,
      CreditCardType: props.paymentCg.CCType,
      CCFourLastNumbers: props.paymentCg.Credit4Digits.substring(props.paymentCg.Credit4Digits.length - 4),
      SubscriberFirstName: props.data.subscriberPersonalData.firstName,
      SubscriberLastName: props.data.subscriberPersonalData.lastName,
      SubscriberEmail: props.data.subscriberPersonalData.email,
      SubscriberCity: props.data.subscriberAddress.city,
      SubscriberStreet: props.data.subscriberAddress.street,
      SubscriberZipCode: props.data.subscriberAddress.zipCode,
      SubscriberApartmentNum: props.data.subscriberAddress.apartmentNum,
      SubscriberHouseNum: props.data.subscriberAddress.houseNum,
      CollaborationApproval: props.data.collaborationApproval,
      SelectedPricePlan: props.data.selectedPricePlan.offerID,
      SubscriberPhoneNumber: props.data.customerPhoneNumber,
      RequestId: props.data.requestId,
      TransferCellcomDu: props.data.transferCellcomDu
    };
    props.submitOwnershipTransferCustomer(data);
  };
  const submitTransferData = () => {
    if (!props.paymentCg.CCToken) {
      setShowErrorMsg(true);
    } else {
      setShowErrorMsg(false);
      submitTransfer();
    }
  };

  return (
    <div className='ownership-transfer-form'>
      <div className='stepContainer'>
        <div className='l-title center'>מהו אמצעי התשלום?</div>
        <div className='m-title center'>אנחנו צריכים אותו כדי לפתוח לך חשבון</div>
        <div>
          <PaymentCG
            isHideTermsCheckbox
            padding='0'
            paymentRequestedQuantity={9}
            noLoader
            type={cgTypeEnum.CHECKCARD}
            isShowIdNumber={true}
            customerId={props.data.customerIdNumber}
            source="OwnershipTransferCustomerBlock"
          />
        </div>
        <div className='continue-button'>
          {showErrorMsg && <div className='error center'>יש להשלים את פרטי התשלום</div>}
          <BtnSubmit onclick={() => submitTransferData()} text={'אישור וסיום'} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  paymentCg: state.PaymentCG,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  submitOwnershipTransferCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPaymentMethod);
